import { render, staticRenderFns } from "./AdComponent.vue?vue&type=template&id=4dc3b58d&scoped=true"
import script from "./AdComponent.vue?vue&type=script&lang=js"
export * from "./AdComponent.vue?vue&type=script&lang=js"
import style0 from "./AdComponent.vue?vue&type=style&index=0&id=4dc3b58d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc3b58d",
  null
  
)

export default component.exports